<template>
  <div class="supplier-payment body">
    <el-container>
      <!-- <Aside /> -->
      <el-main>
        <SearchSuppliers
          :supplier="paymentForm.supplier"
          @selectedSupplier="selectedSupplier"
          :productsLength="productsLength"
          :productSearch="false"
          :searchOnly="false"
          :showLabel="true"
          ref="supplier"
        />

        <div class="bg-White p-3 mt-2">
          <el-row :gutter="10">
            <el-col :xl="6" :lg="6" :md="12" :sm="12">
              <div class="searchForm">
                <label for="search">المبلغ</label>
                <el-input
                  class="mt-2"
                  id="paied"
                  type="number"
                  @focus="$event.target.select()"
                  v-model="paymentForm.paied"
                  controls-position="right"
                  @keyup.enter.native="setNotesFocus"
                ></el-input>
              </div>
            </el-col>
            <el-col :xl="14" :lg="14" :md="12" :sm="12">
              <div class="searchForm">
                <label for="search">ملاحظات</label>
                <el-input
                  class="mt-2"
                  type="text"
                  id="notes"
                  @focus="$event.target.select()"
                  v-model="paymentForm.notes"
                  controls-position="right"
                  @keyup.enter.native="pay"
                ></el-input>
              </div>
            </el-col>
            <el-col :xl="4" :lg="4" :md="12" :sm="12">
              <br />
              <el-button class="mt-2" type="warning" @click="pay()">
                سداد</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import SearchSuppliers from "@/components/Suppliers/Search";
import Aside from "@/components/aside.vue";
import axiosApi from "@/plugins/axios.js";

export default {
  name: "supplierPayment",
  components: { SearchSuppliers, Aside },
  data() {
    return {
      false: false,
      productsLength: 0,
      paymentForm: {
        supplier: null,
        inventory_id: 1,
        paied: "",
        notes: "",
      },
    };
  },

  methods: {
    selectedSupplier(e) {
      this.paymentForm.supplier = e.supplier;
      console.log("selectedSupplier")
      setTimeout(() => {
        document.getElementById("paied").focus();
      }, 100);
    },
    setNotesFocus() {
      setTimeout(() => {
        if (this.paymentForm.paied > 0) {
          document.getElementById("notes").focus();
        }
      }, 100);
    },
    pay() {
      const supplier = this.paymentForm.supplier;
      axiosApi
        .post("suppliers/pay", this.paymentForm)
        .then((res) => {
          this.paymentForm.paied = "";
          this.paymentForm.notes = "";
          this.paymentForm.supplier = null;
          setTimeout(() => {
            this.paymentForm.supplier = supplier;
          }, 100);

          this.$refs.supplier.supplierAccount = +res.data.account + +res.data.balance;

          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حفظ عملية التحصيل بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch(() => {
          this.$notify({
            title: "حدث خطأ",
            message: "عفوا لم تتم العملية ",
            type: "error",
            duration: 1500,
          });
        });
    },
  },
};
</script>
